import { render, staticRenderFns } from "./SectionsPage.vue?vue&type=template&id=83557934&scoped=true&"
import script from "./SectionsPage.vue?vue&type=script&lang=js&"
export * from "./SectionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83557934",
  null
  
)

export default component.exports